import React from "react"
import classnames from "classnames"
import { Tag, H4, Interactive, Space, H5, Content } from "AtomicComponents"
import styles from "./RecallDetail.less"

class RecallDetail extends React.Component {
  render() {
    const {
      serviceActivityCode,
      summaryText,
      description,
      riskText,
      remedyText,
      pendingInitiationDate,
      completedDate,
      vehicleStatus,
      critical,
      pra
    } = this.props
    // 'ACTIVE' | 'PENDING' | 'COMPLETED'
    const status = vehicleStatus && vehicleStatus.toUpperCase()
    const statusText = vehicleStatus
    return (
      <div className={classnames({
        [styles.RecallDetail]: true
      })}>
        <H4 withDetails>
          {description}
        </H4>
        <Space />
        {critical && (status === "ACTIVE" || status === "PENDING") &&
          <Tag color="red">
            CRITICAL
          </Tag>
        }
        {!critical && status !== "ACTIVE" && status !== "PENDING" &&
          <Tag checked color="green">
            COMPLETED
          </Tag>
        }
        {critical && status !== "ACTIVE" && status !== "PENDING" &&
          <Tag checked color="green">
            COMPLETED
          </Tag>
        }
        <Space />
        {status && status !== "ACTIVE" && status !== "PENDING" &&
          <div className={classnames({
            [styles.RecallDetailHeading]: true,
            [styles.WithoutPadding]: true
          })}>
            <div className={classnames({
              [styles.RecallDetailHeadingSection]: true
            })}>
              <div className={classnames({
                [styles.RecallDetailHeadingLabel]: true
              })}>
                <Interactive withDetails>
                  STATUS
                </Interactive>
              </div>
              <div className={classnames({
                [styles.RecallDetailStatus]: true
              })}>
                <strong>{statusText}</strong>
              </div>
            </div>
          </div>
        }
        <div className={classnames({
          [styles.RecallDetailHeading]: true
        })}>
          {status && (status === "ACTIVE" || status === "PENDING") &&
            <div className={classnames({
              [styles.RecallDetailHeadingSection]: true
            })}>
              <div className={classnames({
                [styles.RecallDetailHeadingLabel]: true
              })}>
                <Interactive withDetails>
                  STATUS
                </Interactive>
              </div>
              <div className={classnames({
                [styles.RecallDetailStatus]: true,
                [styles.RecallDetailStatusRed]: status === "ACTIVE",
                [styles.RecallDetailStatusAmber]: status === "PENDING"
              })}>
                <strong>{statusText}</strong>
              </div>
            </div>
          }
          {status === "PENDING" &&
            <div className={classnames({
              [styles.RecallDetailHeadingSection]: true
            })}>
              <div className={classnames({
                [styles.RecallDetailHeadingLabel]: true
              })}>
                <Interactive withDetails>
                  DATE&nbsp;INITIATED
                </Interactive>
              </div>
              <div>
                {pendingInitiationDate}
              </div>
            </div>
          }
          {status !== "ACTIVE" && status !== "PENDING" && completedDate &&
            <div className={classnames({
              [styles.RecallDetailHeadingSection]: true
            })}>
              <div className={classnames({
                [styles.RecallDetailHeadingLabel]: true
              })}>
                <Interactive withDetails>
                  DATE&nbsp;COMPLETED
                </Interactive>
              </div>
              <div>
                {completedDate}
              </div>
            </div>
          }
          {serviceActivityCode &&
            <div className={classnames({
              [styles.RecallDetailHeadingSection]: true
            })}>
              <div className={classnames({
                [styles.RecallDetailHeadingLabel]: true
              })}>
                <Interactive withDetails>
                  RECALL&nbsp;CODE
                </Interactive>
              </div>
              <div>
                {serviceActivityCode}
              </div>
            </div>
          }
          {pra &&
            <div className={classnames({
              [styles.RecallDetailHeadingSection]: true
            })}>
              <div className={classnames({
                [styles.RecallDetailHeadingLabel]: true
              })}>
                <Interactive withDetails>
                  PRA&nbsp;NUMBER
                </Interactive>
              </div>
              <div>
                {pra}
              </div>
            </div>
          }
        </div>
        <div>
          {summaryText && (
            <div>
              <Space />
              <strong>
                Summary
              </strong>
              <Content textAlign="left" xmlString={`<p>${summaryText}</p>`} />
            </div>
          )}
          {riskText && (
            <div>
              <Space />
              <strong>
                Risk
              </strong>
              <Content textAlign="left" xmlString={`<p>${riskText}</p>`} />
            </div>
          )}
          {remedyText && (
            <div>
              <Space />
              <strong>
                Remedy
              </strong>
              <Content textAlign="left" xmlString={`<p>${remedyText}</p>`} />
            </div>
          )}
        </div>
      </div>
    )
  }
}


export default RecallDetail



// WEBPACK FOOTER //
// ./src/AtomicContainers/RecallDetail/RecallDetail.jsx